import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const clickNewIntegration = {
  element: '#new-integration-btn',
  popover: {
    title: 'Getting Started!',
    description:
      'To begin creating your new integration, click on the <strong>&quot;Add Integration&quot;</strong> button.',
    side: 'left',
    align: 'start',
    onNextClick: () => {
      const newIntegrationBtn = document.querySelector('#new-integration-btn');

      if (newIntegrationBtn) {
        newIntegrationBtn.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.moveNext();
        }, 200);
      }
    }
  }
};
